module.exports = __webpack_public_path__ + "img/sun-collection-black.fb8d8d09.svg";